import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { apiGet, getToken } from '../lib/api';
function StatusPill({ s }) {
    const map = {
        queued: 'pill-info',
        running: 'pill-warning',
        completed: 'pill-active',
        failed: 'pill-error',
        cancelled: 'pill-inactive',
    };
    return _jsx("span", { className: map[s], children: s });
}
function fmtSize(bytes) {
    if (!bytes)
        return '—';
    const n = Number(bytes);
    if (n < 1024)
        return `${n} B`;
    if (n < 1024 * 1024)
        return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
export default function Exports() {
    const nav = useNavigate();
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    async function load() {
        setLoading(true);
        try {
            const r = await apiGet('/exports');
            setList(r.exports);
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        load();
        // poll a cada 5s pra atualizar status de jobs em running/queued
        const id = setInterval(() => {
            if (list.some(e => e.status === 'queued' || e.status === 'running'))
                load();
        }, 5000);
        return () => clearInterval(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // unused helper kept for future direct-link usage
    // @ts-ignore
    function _downloadUrl(id) {
        const t = getToken();
        return `/api/exports/${id}/download?_=${t ? Math.random() : ''}`;
    }
    async function download(id) {
        // Token vai no header, então precisamos fazer fetch + blob
        const r = await fetch(`/api/exports/${id}/download`, {
            headers: { authorization: `Bearer ${getToken()}` },
        });
        if (!r.ok) {
            alert('Download falhou: ' + r.status);
            return;
        }
        const blob = await r.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = r.headers.get('content-disposition')?.match(/filename="(.+?)"/)?.[1] ?? `export-${id}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    }
    return (_jsxs("div", { className: "p-8", children: [_jsx(PageHeader, { title: "Exports", subtitle: "Hist\u00F3rico imut\u00E1vel de exports gerados. Cada arquivo tem hash SHA256 pra atestar integridade.", actions: _jsx("button", { className: "btn-primary", onClick: () => nav('/search'), children: "+ Novo export" }) }), _jsxs("div", { className: "card p-3 mb-4 bg-cyan-50 border-cyan-200 text-cyan-800 text-xs", children: [_jsx("strong", { children: "Como criar um export:" }), " vai em ", _jsx("strong", { children: "Buscar Logs" }), ", configura os filtros (per\u00EDodo, IP NAT, etc), clica em Buscar \u2014 depois ", _jsx("strong", { children: "Exportar resultado" }), " pra gerar o PDF/CSV/JSON. Esses jobs aparecem aqui assim que ficam prontos."] }), loading ? (_jsx("div", { className: "card p-12 text-center text-ink-400", children: "Carregando\u2026" })) : list.length === 0 ? (_jsxs("div", { className: "card p-12 text-center", children: [_jsx("div", { className: "text-4xl mb-3", children: "\u2193" }), _jsx("h3", { className: "font-semibold mb-1", children: "Nenhum export ainda" }), _jsxs("p", { className: "text-sm text-ink-500", children: ["Gere o primeiro export pela tela ", _jsx("strong", { children: "Buscar Logs" }), "."] })] })) : (_jsx("div", { className: "card overflow-x-auto", children: _jsxs("table", { className: "w-full text-sm", children: [_jsx("thead", { className: "bg-ink-50 border-b border-ink-200", children: _jsxs("tr", { className: "text-left text-ink-600 text-xs", children: [_jsx("th", { className: "px-4 py-2.5 font-semibold", children: "Quando" }), _jsx("th", { className: "px-4 py-2.5 font-semibold", children: "Solicitante" }), _jsx("th", { className: "px-4 py-2.5 font-semibold", children: "Of\u00EDcio / Processo" }), _jsx("th", { className: "px-4 py-2.5 font-semibold", children: "Eventos" }), _jsx("th", { className: "px-4 py-2.5 font-semibold", children: "Tamanho" }), _jsx("th", { className: "px-4 py-2.5 font-semibold", children: "Status" }), _jsx("th", { className: "px-4 py-2.5 font-semibold text-right", children: "A\u00E7\u00E3o" })] }) }), _jsx("tbody", { children: list.map(j => (_jsxs("tr", { className: "border-b border-ink-100 hover:bg-ink-50/50", children: [_jsxs("td", { className: "px-4 py-3 text-xs", children: [new Date(j.createdAt).toLocaleString('pt-BR'), _jsxs("div", { className: "text-[10px] text-ink-400", children: ["por ", j.createdBy.name] })] }), _jsx("td", { className: "px-4 py-3 text-xs", children: j.requestingAuthority ?? '—' }), _jsx("td", { className: "px-4 py-3 text-xs font-mono", children: j.courtOrderRef ?? '—' }), _jsx("td", { className: "px-4 py-3 text-xs", children: j.rowCount ? Number(j.rowCount).toLocaleString('pt-BR') : '—' }), _jsx("td", { className: "px-4 py-3 text-xs", children: fmtSize(j.fileSizeBytes) }), _jsx("td", { className: "px-4 py-3", children: _jsx(StatusPill, { s: j.status }) }), _jsx("td", { className: "px-4 py-3 text-right", children: j.status === 'completed' && (_jsxs("button", { className: "btn-default text-xs py-1", onClick: () => download(j.id), children: ["\u2193 baixar ", j.format.toUpperCase()] })) })] }, j.id))) })] }) }))] }));
}
